module.exports = __webpack_public_path__ + "static/media/3.-Learn-oaknut-illustration.7bd45b96.svg";